import React, { useEffect, useState } from 'react';
import SumsubWebSdk from '@sumsub/websdk-react';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getLocalStorage } from 'utils/sessionStorage';
import userApi from 'api/userApi';
import { showErrorModal, showInfoModal } from 'components/Modals/CommonModals';
import kycApi from 'api/kyc';
import InfomationIcon from 'assets/icons/InfomationIcon';
import WarningIcon from 'assets/icons/WarningIcon';
import { NavLink } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import { platformStates } from 'redux/platformSlice';
import Typo from 'consts/typography';
import useUserDetail from 'hooks/useUserDetail';

interface KYCProps {}

const KYC: React.FunctionComponent<KYCProps> = () => {
  const t = useAppTranslation();
  const [accessToken, setAccessToken] = useState<string>('');
  const { getUserDetail } = useUserDetail();
  const navigate = useNavigate();
  const { isPhone } = useAppSelector(platformStates);
  const accessTokenExpirationHandler = () => {};

  const redirectHome = () => {
    navigate('/', { replace: true });
  };

  const showPopup = (title: string, content: string, icon: React.ReactNode) => {
    showInfoModal({
      title,
      content,
      okText: t('backHome'),
      onOk: () => {
        getUserDetail();
        redirectHome();
      },
      width: 360,
      icon,
    });
  };

  const fetchData = async () => {
    if (!getLocalStorage('access_token_terabet')) {
      redirectHome();
      return;
    }
    const { ok: userRequestResult, body: userResponse } = await userApi.getUser();
    if (!userRequestResult || !userResponse) {
      showErrorModal({
        title: t('errors.fetchApi.title'),
        content: t('errors.fetchApi.message'),
        okText: t('backHome'),
        onOk: redirectHome,
      });
      return;
    }

    switch (userResponse?.kyc?.status) {
      case 'APPROVED':
        showPopup(t('notification'), t('popup.kyc.message.approved'), <InfomationIcon />);
        return;
      case 'REJECTED':
        showPopup(t('popup.kyc.title.required'), t('popup.kyc.message.rejected'), <WarningIcon />);
        return;
      case 'PENDING':
        showPopup(t('notification'), t('popup.kyc.message.pending'), <InfomationIcon />);
        return;
      default:
        break;
    }

    const { ok: kycRequestResult, body: kycResponse } = await kycApi.getAccessToken();
    if (!kycRequestResult || !kycResponse) {
      showErrorModal({
        title: t('errors.fetchApi.title'),
        content: t('errors.fetchApi.message'),
        okText: t('backHome'),
        onOk: redirectHome,
      });
      return;
    }

    setAccessToken(kycResponse.accessToken);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="kyc-page relative">
      <NavLink to={'/'} className={'back-icon flex-row items-center gap-1'}>
        <BiArrowBack />
        <span className={`primary-text-color ${isPhone ? Typo.p4 : Typo.p2}`}>Back to Terabet</span>
      </NavLink>
      {!accessToken ? (
        <Spin size="large" />
      ) : (
        <div className="kyc-form">
          <SumsubWebSdk
            accessToken={accessToken}
            expirationHandler={accessTokenExpirationHandler}
            config={{
              lang: 'en',
              country: 'USA',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default KYC;
